import { Injectable, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class NotificationService {

  public toastAlert: EventEmitter<any> = new EventEmitter();

  constructor(public snackBarService: MatSnackBar) {
  }

  // for toaster alerts
  toast(type: string, message: string, title?: string, options?: any) {
    this.toastAlert.next({type, message, title, options});
  }

  snackBar(msg, label, panelClass= 'success-snackbar') {
    this.snackBarService.open(msg, label, {
      duration: 5000,
      panelClass: [panelClass]
    });
  }
}
